const passwordLengthValidate = (password: string, name: string) => {
  let errMsg = undefined;

  if (password) {
    if (password.length < 6 || password.length > 20) {
      errMsg = "Password should have 6 to 20 characters.";
    }
  } else {
    errMsg = `"${name}" field shouldn't be empty.`;
  }

  return errMsg;
};

export default passwordLengthValidate;
